import React from "react";

type Props = {
  children: React.ReactNode;
};

export default function PageContainer({ children }: Props) {
  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Background image */}
      <img
        src="/images/rainforest-falls-theme-art-bg.jpg"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Page content */}
      <div className="relative min-h-screen">
        {/* Compact Banner */}


        {/* Main Content */}
        <div className="mx-auto w-full max-w-xl px-4 py-4">
          {children}
        </div>
      </div>
    </div>
  );
}